import styled from 'foundations-theming/utils';
import { getDisplayName, getId, isUserEditable } from 'find-and-filter-data/views-schema/public';
import NavViewLinkActions, { MenuButton } from './NavViewLinkActions';
import ViewCount from './ViewCount';
import { Button } from 'foundations-components/transitional/components/Button';
import { useCallback } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HoverWrapper = styled.div.withConfig({
  displayName: "LinkWrapper__HoverWrapper",
  componentId: "sc-16o2ukq-0"
})(["font-weight:", " !important;padding-block:", ";position:relative;width:100%;overflow:hidden;:hover ", "{opacity:1;}:focus-within ", "{opacity:1;}"], ({
  selected
}) => selected ? '600' : '400', ({
  theme
}) => theme.space['25'], MenuButton, MenuButton);
const LinkWrapper = ({
  disabled,
  view,
  viewId,
  handleViewMemberClick,
  buttonContent,
  actions,
  wrapperEl
}) => {
  const selected = viewId === getId(view);
  const viewIsEditable = isUserEditable(view) && !disabled && Boolean(actions.length);
  const onClickHandler = useCallback(() => handleViewMemberClick(disabled, selected, view), [handleViewMemberClick, disabled, selected, view]);
  const Wrapper = wrapperEl();
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(HoverWrapper, {
      selected: selected,
      children: /*#__PURE__*/_jsxs(Wrapper, {
        selected: selected,
        "data-test-id": "view-wrapper",
        children: [/*#__PURE__*/_jsx(Button, {
          disabled: disabled,
          "data-test-id": getDisplayName(view),
          onClick: onClickHandler,
          use: "unstyled",
          truncate: true,
          truncateStringProps: {
            justifyContent: 'space-between',
            useFlex: true,
            fixedChildren: disabled ? null : /*#__PURE__*/_jsx(ViewCount, {
              view: view
            })
          },
          block: true,
          paddingBlock: "100",
          paddingInlineStart: "200",
          paddingInlineEnd: "600",
          color: "text-core-default",
          children: buttonContent || getDisplayName(view)
        }), viewIsEditable && /*#__PURE__*/_jsx(NavViewLinkActions, {
          actions: actions
        })]
      })
    })
  );
};
LinkWrapper.displayName = 'LinkWrapper';
export default LinkWrapper;